<template>
    <div>
      <div v-if="isLoading" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t('Loading...') }}</strong>
      </div>
      <b-card no-body v-if="editCurrentRow && !isLoading" style="min-height:300px">
        <sidebar-menu class="user-sidebar" v-click-outside="clickOutsideSideBarCustomer" style="z-index:100 !important;"
           ref="sidebarmenucustomer" :menu="menu" theme="white-theme" :showOneChild="true" width="250px" widthCollapsed="34px" :collapsed="true" :hideToggle="true" @item-click="onItemClick"/>

        <div style="margin-left:38px">
          <Main v-if="currentComponent == 1"
            ref="Main"
            :currentRow="editCurrentRow"
            :userInfo="editUserInfo"/>

          <Additional v-if="currentComponent == 2"
          ref="Additional"
          :userInfo="editUserInfo"
          :additionalParams="additionalParams"
          @IsLifestreamEmailSync="LifestreamEmailSync"
          @makeToasts="makeToasts"/>

          <Contacts v-if="currentComponent == 3"
          ref="Contacts"
          :currentRow="editCurrentRow"
          :userInfo="editUserInfo"
          @makeToasts="makeToasts"/>

          <AdditionalContacts v-if="currentComponent == 4"
          ref="AdditionalContacts"
          :ceo="editCeo"
          :accountant="editAccountant"
          :tableContacts="editTableContacts"
          @deleteContact="deleteContact"/>

          <Personal v-if="currentComponent == 5"
          ref="Personal"
          :userInfo="editUserInfo"
          @makeToasts="makeToasts"/>

          <Groups v-if="currentComponent == 6"
          ref="Groups"
          :currentRow="editCurrentRow"
          :userInfo="editUserInfo"
          @makeToasts="makeToasts"/>

          <Other v-if="currentComponent == 7"
          ref="Other"
          :currentRow="editCurrentRow"
          :userInfo="editUserInfo"/>

          <Documents v-if="currentComponent == 8"
          ref="Documents"
          :currentRow="editCurrentRow"
          @makeToasts="makeToasts"/>

          <AdditionalInfo v-if="currentComponent == 9"
          ref="AdditionalInfo"
          :userInfo="userInfo"/>

          <b-row style="padding-bottom:10px" v-if="[1,2,3,4,5,6,7,8,9].includes(currentComponent)">
            <b-col cols="9" md="8">
            </b-col>
            <b-col cols="2" md="4">
              <b-row>
                <b-col cols="6">
                  <md-button @click.stop="undoEdit"  >{{ $t('Cancel') }}</md-button>
                </b-col>
                <b-col cols="6">
                  <md-button @click.stop="updateUser" class="md-raised">{{ $t('Save') }}</md-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <div v-if="[10,11,12,13,14].includes(currentComponent)" style="margin-left:38px">
          <Accounts v-if="currentComponent == 10 && !editCurrentAccountInfo"
          ref="AccountsTab"
          :currentRow="editCurrentRow"
          @clickOnAccount="openFullAccountInfo"
          @refreshTable="refreshAccounts"/>
          <FormAccount v-if="currentComponent == 10 && editCurrentAccountInfo"
            ref="FormAccount"
            :accountInfo="editCurrentAccountInfo"
            @close="editCurrentAccountInfo = null"
            @back="editCurrentAccountInfo = null"
            @makeToasts="makeToasts"
            @refreshTable="refreshAccounts"/>

          <ServiceLinks v-if="currentComponent == 11"
          ref="ServiceLinks"
          :listOfChargePolicy="listOfChargePolicy"
          :listOfCoefficientScheme="listOfCoefficientScheme"
          :currentRow="editCurrentRow"
          @makeToasts="makeToasts"/>

          <TariffLinks v-if="currentComponent == 12"
          ref="TariffLinks"
          :listOfCoefficientScheme="listOfCoefficientScheme"
          :listOfChargePolicy="listOfChargePolicy"
          :currentRow="editCurrentRow"
          @makeToasts="makeToasts"/>

          <TechnicalParameters v-if="currentComponent == 13"
          ref="TechnicalParameters"
          :currentRow="editCurrentRow"
          @makeToasts="makeToasts"/>

          <AccessCards v-if="currentComponent == 14"
          ref="AccessCards"
          :currentRow="editCurrentRow"/>
        </div>
        <div v-if="[15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30].includes(currentComponent)" style="margin-left:38px; ">
          <div style="margin:1%">
            <ReportPayments v-if="currentComponent == 15"
            ref="reportPayments"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportInternalTransfer v-if="currentComponent == 16"
            ref="reportInternalTransfer"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportExpiringPayments v-if="currentComponent == 17"
            ref="reportExpiringPayments"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportOtherCharges v-if="currentComponent == 18"
            ref="reportOtherCharges"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportsDocuments v-if="currentComponent == 19"
            ref="reportDocuments"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            :selectTypeDocuments="selectTypeDocuments"/>

            <ReportGeneral v-if="currentComponent == 20"
            ref="reportGeneral"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportServices v-if="currentComponent == 21"
            ref="reportServices"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportCustomCharges v-if="currentComponent == 22"
            ref="reportCustomСharges"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportTraffic v-if="currentComponent == 23"
            ref="reportTraffic"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            :selectTypeTraffic="selectTypeTraffic"/>

            <ReportDetailedTraffic v-if="currentComponent == 24"
            ref="reportDetailedTraffic"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            :selectCollector="selectCollector"/>

            <ReportTelephony v-if="currentComponent == 25"
            ref="reportTelephony"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportTelephonyDirections v-if="currentComponent == 26"
            ref="reportTelephonyDirections"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportBlockings v-if="currentComponent == 27"
            ref="reportBlockings"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportUserChangeLog v-if="currentComponent == 28"
            ref="reportUserChangeLog"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            :selectTypeUsers="selectTypeUsers"/>

            <ReportSessions v-if="currentComponent == 29"
            ref="reportSessions"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>

            <ReportDHCPLease v-if="currentComponent == 30"
            ref="reportDHCPLease"
            :dateStart="dateStart"
            :dateEnd="dateEnd"
            :filter="reportFilter"
            :userId="editCurrentRow.user_id"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"/>
          </div>
        </div>

      </b-card>
    </div>
</template>

<style>
.margin-left-200 {
  margin-left:200px;
}

.v-sidebar-menu.vsm_white-theme.user-sidebar {
  display: inline-flex;
  position: absolute;
  min-height: 200px;

  box-shadow: 5px 0 5px -5px rgba(0,0,0,.2), 5px 0 5px -5px rgba(0,0,0,.14), 5px 0 5px -5px rgba(0,0,0,.12);
}

.v-sidebar-menu.vsm_white-theme.user-sidebar .vsm--link {
  padding: 2px;
  font-size: 12px;
}

.v-sidebar-menu.vsm_white-theme.user-sidebar .vsm--link:hover,
.v-sidebar-menu.vsm_white-theme.user-sidebar .vsm--mobile-item>.vsm--item>.vsm--link {
  color: black;
  background-color: #c8c8c8 !important;
  font-weight: bold;
  font-size: 13px;
}

</style>

<script>
import Main from './main/main'
import Additional from './additional/main'
import Contacts from './contacts/main'
import AdditionalContacts from './additionalContacts/main'
import Groups from './groups/main'
import AccessCards from './accessCards/main'
import Other from './others/main'
import Documents from './documents/main'
import AdditionalInfo from './additionalInfo/main'
import ServiceLinks from './serviceLinks/main'
import TariffLinks from './tariffLinks/main'
import TechnicalParameters from './technicalParameters/main'
import Personal from './personal/main'

import FormAccount from '@/pages/users/accounts/detail/main'

import ReportPayments from '@/pages/reports/payments/payments/main.vue'
import ReportInternalTransfer from '@/pages/reports/payments/internalTransfer/main.vue'
import ReportExpiringPayments from '@/pages/reports/payments/expiringPayments/main.vue'
import ReportOtherCharges from '@/pages/reports/payments/otherCharges/main.vue'
import ReportsDocuments from '@/pages/reports/payments/documents/main.vue'
import ReportGeneral from '@/pages/reports/services/general/main.vue'
import ReportServices from '@/pages/reports/services/services/main.vue'
import ReportCustomCharges from '@/pages/reports/services/customChargesReport/main.vue'
import ReportTraffic from '@/pages/reports/services/traffic/main.vue'
import ReportDetailedTraffic from '@/pages/reports/services/detailedTraffic/main.vue'
import ReportTelephony from '@/pages/reports/services/telephony/main.vue'
import ReportTelephonyDirections from '@/pages/reports/services/telephonyDirectionsReport/main.vue'
import ReportBlockings from '@/pages/reports/other/blocking/main.vue'
import ReportUserChangeLog from '@/pages/reports/other/changeLog/main.vue'
import ReportSessions from '@/pages/reports/other/sessions/main.vue'
import ReportDHCPLease from '@/pages/reports/other/dhcpLease/main.vue'

import Accounts from '@/components/tables/users/Accounts'

export default {
  components: {
    Main,
    Additional,
    Contacts,
    AdditionalContacts,
    Groups,
    Other,
    Documents,
    AdditionalInfo,
    Accounts,
    ServiceLinks,
    AccessCards,
    FormAccount,
    ReportPayments,
    ReportInternalTransfer,
    ReportExpiringPayments,
    ReportOtherCharges,
    ReportsDocuments,
    ReportGeneral,
    ReportServices,
    ReportCustomCharges,
    ReportTraffic,
    ReportDetailedTraffic,
    ReportTelephony,
    ReportTelephonyDirections,
    ReportBlockings,
    ReportUserChangeLog,
    ReportSessions,
    ReportDHCPLease,
    TariffLinks,
    TechnicalParameters,
    Personal
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      isSideBarCollapsed: true,
      currentComponent: 1,
      selectCollector: 0,
      selectTypeTraffic: 0,
      selectTypeUsers: 0,
      selectTypeDocuments: 1,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      is_dev: process.env.NODE_ENV === 'development',
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      reportFilter: null,
      reportFilterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      reportFilterOptionsDocuments: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: true,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      reportFilterOptionsUserChangeLog: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: true,
        isFilterCollector: false
      },
      reportFilterOptionsTraffic: {
        isFilterGroup: false,
        isFilterTypeTraffic: true,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      reportFilterOptionsCollector: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: true
      },
      additionalParams: null,
      editAdditionalContacts: null,
      ceo: null,
      editCeo: null,
      accountant: null,
      editAccountant: null,
      tableContacts: [],
      editTableContacts: [],
      editUserInfo: null,
      userInfo: null,
      editCurrentRow: null,
      editCurrentAccountInfo: null,
      exposedContact: [],
      emptyContact: {
        'descr': '',
        'reason': '',
        'person': '',
        'person_short': '',
        'contact': '',
        'email': '',
        'id_exec_man': '0'
      },
      isLoading: true,
      menu: [
        {
          title: this.$i18n.t('Customer'),
          icon: 'fa fa-user',
          child: [
            {
              title: this.$i18n.t('Main'),
              tabcounter: 1
            },
            {
              title: this.$i18n.t('Additional'),
              tabcounter: 2
            },
            {
              title: this.$i18n.t('Contacts'),
              tabcounter: 3
            },
            {
              title: this.$i18n.t('Additional contacts'),
              tabcounter: 4
            },
            {
              title: this.$i18n.t('Personal'),
              tabcounter: 5
            },
            {
              title: this.$i18n.t('Groups'),
              tabcounter: 6
            },
            {
              title: this.$i18n.t('Other'),
              tabcounter: 7
            },
            {
              title: this.$i18n.t('Documents'),
              tabcounter: 8
            },
            {
              title: this.$i18n.t('Additional info'),
              tabcounter: 9
            }
          ]
        },
        {
          title: this.$i18n.t('Tariffication'),
          icon: 'fa fa-coins',
          child: [
            {
              title: this.$i18n.t('Accounts'),
              tabcounter: 10
            },
            {
              title: this.$i18n.t('Service links'),
              tabcounter: 11
            },
            {
              title: this.$i18n.t('Tariff links'),
              tabcounter: 12
            },
            {
              title: this.$i18n.t('Technical parameters'),
              tabcounter: 13
            },
            {
              title: this.$i18n.t('Access cards'),
              tabcounter: 14
            }
          ]
        },
        {
          title: this.$i18n.t('Reports.Payments'),
          icon: 'fa fa-money-check-alt',
          child: [
            {
              title: this.$i18n.t('Payments'),
              tabcounter: 15
            },
            {
              title: this.$i18n.t('Internal transfer'),
              tabcounter: 16
            },
            {
              title: this.$i18n.t('Expiring payments'),
              tabcounter: 17
            },
            {
              title: this.$i18n.t('Other charges'),
              tabcounter: 18
            },
            {
              title: this.$i18n.t('Documents'),
              tabcounter: 19
            }
          ]
        },
        {
          title: this.$i18n.t('Reports.Services'),
          icon: 'fa fa-concierge-bell',
          child: [
            {
              title: this.$i18n.t('General'),
              tabcounter: 20
            },
            {
              title: this.$i18n.t('Services'),
              tabcounter: 21
            },
            {
              title: this.$i18n.t('Custom charges report'),
              tabcounter: 22
            },
            {
              title: this.$i18n.t('Traffic'),
              tabcounter: 23
            },
            {
              title: this.$i18n.t('Detailed traffic'),
              tabcounter: 24
            },
            {
              title: this.$i18n.t('TelephonyReports'),
              tabcounter: 25
            },
            {
              title: this.$i18n.t('Telephony directions report'),
              tabcounter: 26
            }
          ]
        },
        {
          title: this.$i18n.t('Reports.Other'),
          icon: 'fa fa-chart-bar',
          child: [
            {
              title: this.$i18n.t('Blockings'),
              tabcounter: 27
            },
            {
              title: this.$i18n.t('User change log'),
              tabcounter: 28
            },
            {
              title: this.$i18n.t('Sessions'),
              tabcounter: 29
            },
            {
              title: this.$i18n.t('DHCP lease'),
              tabcounter: 30
            }
          ]
        }
      ]
    }
  },
  methods: {
    LifestreamEmailSync (val) {
      this.editUserInfo.isLifestreamEmailSync = val
    },
    deleteContact (contact) {
      if (!contact) {
        return
      }
      this.editTableContacts = this.editTableContacts.filter((value) => {
        return value !== contact
      })
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.reportFilter = value
    },
    async updateUser () {
      if (this.editUserInfo.mobile_telephone.includes('_') ||
      this.editUserInfo.mobile_telephone_second.includes('_')) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Phone number is not fit to format'), 'Error')
        return
      }
      if (this.editUserInfo.password !== this.editCurrentRow.password) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Password doesn`t match'), 'Error')
        return
      }
      if (this.editUserInfo.password.length === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Empty password'), 'Error')
        return
      }
      if (isNaN(this.editUserInfo.birthday)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Birthday is mandatory'), 'Error')
        return
      }
      if (isNaN(this.editUserInfo.connect_date)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Connect date is mandatory'), 'Error')
        return
      }

      for (let el of this.$store.getters['Users/USERS'].users) {
        if (el.login === this.editUserInfo.login && el.user_id !== this.editUserInfo.user_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This user login already exists'), 'Error')
          return
        }
      }

      let isValidLogin = await this.loginValidation(this.editUserInfo.login)
      if (isValidLogin) {
        this.exposedContact = []
        for (let i in this.editTableContacts) {
          this.exposedContact.push(this.editTableContacts[i])
        }
        this.exposedContact.push(this.editCeo, this.editAccountant)
        let payload = {
          user_id: this.currentRow.user_id,
          contact: this.exposedContact
        }
        this.$store.dispatch('Users/CREATE_USER_CONTACTS', payload, payload)
        this.editUserInfo.port_number = Number(this.editUserInfo.port_number)
        this.editUserInfo.full_name = this.editUserInfo.full_name
        let userFullInfo = Object.assign(this.editCurrentRow, this.editUserInfo)
        let response = this.$store.dispatch('Users/UPDATE_USERS', userFullInfo)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.load(false)
            this.$root.$emit('makeToasts')
            this.$emit('refreshRow', userFullInfo.user_id)
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('"Login" is incorrect'), 'Error')
      }
    },
    async loginValidation (login) {
      if (login.length === 0) {
        return false
      }
      let strArray = login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-+_/()'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })

      return strArray.join('').length === login.length
    },
    openFullAccountInfo (row) {
      this.editCurrentAccountInfo = row
    },
    reportGeneratePayments () {
      this.$refs.reportPayments.load()
    },
    reportGenerateInternalTransfer () {
      this.$refs.reportInternalTransfer.load()
    },
    reportGenerateExpiringPayments () {
      this.$refs.reportExpiringPayments.load()
    },
    reportGenerateOtherCharges () {
      this.$refs.reportOtherCharges.load()
    },
    reportGenerateDocuments () {
      this.$refs.reportDocuments.load()
    },
    reportGenerateGeneral () {
      this.$refs.reportGeneral.load()
    },
    reportGenerateServices () {
      this.$refs.reportServices.load()
    },
    reportGenerateTraffic () {
      this.$refs.reportTraffic.load()
    },
    reportGenerateDetailedTraffic () {
      this.$refs.reportDetailedTraffic.load()
    },
    reportGenerateBlockings () {
      this.$refs.reportBlockings.load()
    },
    reportGenerateUserChangeLog () {
      this.$refs.reportUserChangeLog.load()
    },
    reportGenerateDHCPLease () {
      this.$refs.reportDHCPLease.load()
    },
    reportGenerateSessions () {
      this.$refs.reportSessions.load()
    },
    reportGenerateTelephony () {
      this.$refs.reportTelephony.load()
    },
    reportGenerateTelephonyDirections () {
      this.$refs.reportTelephonyDirections.load()
    },
    reportGenerateCustom () {
      this.$refs.reportCustomСharges.load()
    },
    load (isValidPhones = true) {
      if (this.editCurrentRow) {
        this.ceo = null
        this.accountant = null
        this.tableContacts = []

        if (Object.keys(this.$store.getters['Users/USER_CONTACTS']).length > 0) {
          let copyContacts = JSON.parse(JSON.stringify(this.$store.getters['Users/USER_CONTACTS']))
          for (let el of copyContacts) {
            if (el.id_exec_man === 1) {
              this.ceo = el
            }
            if (el.id_exec_man === 2) {
              this.accountant = el
            }
          }
          if (!this.ceo) {
            this.ceo = JSON.parse(JSON.stringify(this.emptyContact))
            this.ceo.id_exec_man = 1
          }
          if (!this.accountant) {
            this.accountant = JSON.parse(JSON.stringify(this.emptyContact))
            this.accountant.id_exec_man = 2
          }
          this.tableContacts = copyContacts.filter(function (value) {
            return value.id_exec_man === 0
          })
        } else {
          this.ceo = JSON.parse(JSON.stringify(this.emptyContact))
          this.ceo.id_exec_man = 1
          this.accountant = JSON.parse(JSON.stringify(this.emptyContact))
          this.accountant.id_exec_man = 2
          this.tableContacts = []
        }
        let copyUserInfo = JSON.parse(JSON.stringify(this.$store.getters['Users/FULL_INFO_USERS']))

        if (isValidPhones && ((copyUserInfo.mobile_telephone.length && copyUserInfo.mobile_telephone.length !== this.phoneFormat.length) ||
         (copyUserInfo.mobile_telephone_second.length && copyUserInfo.mobile_telephone_second.length !== this.phoneFormat.length))) {
          this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Stored phone is not fit to phone format'), 'Error')
        }
        this.additionalParams = JSON.parse(JSON.stringify(this.$store.getters['Settings/ADDITIONAL']))
        this.additionalParams = this.additionalParams.filter(function (value, index, arr) {
          return value.visible !== false
        })
        for (let paramId in this.additionalParams) {
          let isFound = false
          for (let userParamId in copyUserInfo.additional_params) {
            if (copyUserInfo.additional_params[userParamId].id === this.additionalParams[paramId].id) {
              copyUserInfo.additional_params[userParamId].display_name = this.additionalParams[paramId].display_name
              isFound = true
              break
            }
          }
          if (!isFound) {
            this.additionalParams[paramId].value = ''
            copyUserInfo.additional_params.push(this.additionalParams[paramId])
          }
        }
        if (copyUserInfo.doc_profile_id < 0) {
          copyUserInfo.doc_profile_id = 1
        }
        this.userInfo = copyUserInfo
      }
      this.isLoading = false
    },
    undoEdit () {
      this.editCurrentRow = JSON.parse(JSON.stringify(this.currentRow))
      this.editUserInfo = JSON.parse(JSON.stringify(this.userInfo))
      this.editCeo = JSON.parse(JSON.stringify(this.ceo))
      this.editAccountant = JSON.parse(JSON.stringify(this.accountant))
      this.editTableContacts = JSON.parse(JSON.stringify(this.tableContacts))
    },
    refreshAccounts () {
      this.$emit('refreshRow', this.editCurrentRow.user_id, true)
    },
    onChangedTypeDocuments (value) {
      this.selectTypeDocuments = (value)
    },
    onChangedTypeUsers (value) {
      this.selectTypeUsers = (value)
    },
    onChangedTypeTraffic (value) {
      this.selectTypeTraffic = (value)
    },
    onChangedCollector (value) {
      this.selectCollector = value
    },
    clickOutsideSideBarCustomer: function () {
      this.$refs.sidebarmenucustomer.isCollapsed = true
    },
    onItemClick (event, item, node) {
      if (item.tabcounter) {
        this.currentComponent = item.tabcounter
      }
    }
  },
  watch: {
    ceo: function (ceo) {
      this.editCeo = JSON.parse(JSON.stringify(ceo))
    },
    accountant: function (accountant) {
      this.editAccountant = JSON.parse(JSON.stringify(accountant))
    },
    userInfo: function (val) {
      this.editUserInfo = JSON.parse(JSON.stringify(val))
    },
    tableContacts: function (val) {
      this.editTableContacts = JSON.parse(JSON.stringify(val))
    },
    currentRow: function (val) {
      this.editCurrentRow = JSON.parse(JSON.stringify(val))
      this.editCurrentAccountInfo = null
      this.load()
    }
  },
  async mounted () {
    await this.$store.dispatch('Settings/GET_ADDITIONAL')
    await this.$store.dispatch('Users/GET_FULL_INFO_USERS', this.currentRow.user_id)
    await this.$store.dispatch('Users/GET_USER_CONTACTS', this.currentRow.user_id)
    await this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS_PHONE_FORMAT')
    // is CardUser
    if ('allBalance' in this.currentRow && 'user_int_status' in this.currentRow) {
      this.$store.dispatch('Users/GET_USER', this.currentRow.user_id).then(response => {
        this.currentRow = this.$store.getters['Users/USER']
      })
    }
    this.editCurrentRow = JSON.parse(JSON.stringify(this.currentRow))
    this.editCurrentRow.confirmPassword = JSON.parse(JSON.stringify(this.editCurrentRow.password))
    this.editCurrentAccountInfo = null

    this.$store.dispatch('ReferenceBooks/GET_BUILDINGS')
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
    this.$store.dispatch('Settings/GET_FIREWALLS')
    this.$store.dispatch('Settings/GET_PROFILES_OF_DOCUMENTS')
    this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_ACCOUNTING_PERIODS')
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Tariffing/GET_CHARGE_POLICIES')
    this.$store.dispatch('Tariffing/GET_COEFFICIENT_SCHEME')

    this.load()

    this.$watch(
      () => {
        return this.$refs.sidebarmenucustomer ? this.$refs.sidebarmenucustomer.isCollapsed : true
      },
      (val) => {
        this.isSideBarCollapsed = val
      }
    )
  },
  computed: {
    phoneFormat () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS_PHONE_FORMAT']
    },
    listOfChargePolicy () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        el.value = el.policy_id
        el.text = el.name + ' (' + el.policy_id + ')'
        tmp.push(el)
      }
      return tmp
    },
    listOfCoefficientScheme () {
      let tmp = [
        {value: 0, text: ''}
      ]
      for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/main.vue